import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Fab, Action } from "react-tiny-fab";
import "react-tiny-fab/dist/styles.css";
import AddIcon from "@mui/icons-material/Add";
import CreateIcon from "@mui/icons-material/Create";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AddClient from "../Clients/AddClient";
import { useTranslation, Trans } from "react-i18next";

const FabButton = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage;
  const location = useLocation();
  const mainButtonStyles = { backgroundColor: "#1976D2" };
  const [open, setOpen] = useState(false);
  const history = useHistory();
  // if(location.pathname === '/invoice') return null
  function addInvoice() {
    history.push(`/${currentLang}/app/add/invoice`);
  }
  return (
    <div>
      <AddClient setOpen={setOpen} open={open} />
      <Fab
        mainButtonStyles={mainButtonStyles}
        icon={<AddIcon />}
        alwaysShowTitle={true}
        style={{ bottom: "60px" }}
      >
        {location.pathname !== `/${currentLang}/app/add/invoice` && (
          <Action text={t("New_Invoice")} onClick={addInvoice}>
            <CreateIcon />
          </Action>
        )}

        <Action
          text={t("New_Customer")}
          onClick={() => setOpen((prev) => !prev)}
        >
          <PersonAddIcon />
        </Action>
      </Fab>
    </div>
  );
};

export default FabButton;
